"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRY_AGAIN_BUTTON = exports.ERROR_DESCRIPTION = exports.ERROR_TITLE = exports.CLOSE_BUTTON_ALT_TEXT = exports.LOG_OUT_BUTTON = exports.CONTINUE_BUTTON = exports.ACCEPT_BUTTON_LOADER_ALT_TEXT = exports.ACCEPT_BUTTON = exports.MESSAGE_DESCRIPTION = exports.MESSAGE_TITLE = exports.CONTENT_DESCRIPTION_2 = exports.CONTENT_DESCRIPTION_1 = exports.TITLE = exports.BASE_KEY = void 0;
exports.BASE_KEY = 'mbESignInterstitial';
exports.TITLE = `${exports.BASE_KEY}.title`;
exports.CONTENT_DESCRIPTION_1 = `${exports.BASE_KEY}.contentDescription1`;
exports.CONTENT_DESCRIPTION_2 = `${exports.BASE_KEY}.contentDescription2`;
exports.MESSAGE_TITLE = `${exports.BASE_KEY}.messageTitle`;
exports.MESSAGE_DESCRIPTION = `${exports.BASE_KEY}.messageDescription`;
exports.ACCEPT_BUTTON = `${exports.BASE_KEY}.acceptButton`;
exports.ACCEPT_BUTTON_LOADER_ALT_TEXT = `${exports.BASE_KEY}.a11y.acceptButtonLoader`;
exports.CONTINUE_BUTTON = `${exports.BASE_KEY}.continueButton`;
exports.LOG_OUT_BUTTON = `${exports.BASE_KEY}.logOutButton`;
exports.CLOSE_BUTTON_ALT_TEXT = `${exports.BASE_KEY}.a11y.crossIcon`;
exports.ERROR_TITLE = `${exports.BASE_KEY}.errorTitle`;
exports.ERROR_DESCRIPTION = `${exports.BASE_KEY}.errorDescription`;
exports.TRY_AGAIN_BUTTON = `${exports.BASE_KEY}.tryAgainButton`;
//# sourceMappingURL=eSign.literals.js.map